let web_storage;

const EncryptionUtils = require('./EncryptionUtils');

// Keys that should have their values encrypted
const KEYS_WITH_ENCRYPTION = ['current_user'];

function storageAvailable(type) {
  try {
    var storage = window[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  }
  catch (e) {
    return e instanceof DOMException && (
      // everything except Firefox
      e.code === 22 ||
      // Firefox
      e.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' ||
      // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0;
  }
}

function setWebStorage() {
  if (storageAvailable('localStorage')) {
    // Yippee! We can use localStorage awesomeness
    web_storage = localStorage;
  } else {
    // Too bad, no localStorage for us
  }
}
setWebStorage();

// if (storageAvailable('sessionStorage')) {
//   web_storage = sessionStorage;
// }

function getFromWebStorage(keyName) {
  // setWebStorage();
  if (web_storage && web_storage.getItem) {
    try {
      const data = JSON.parse(web_storage.getItem(keyName));

      // Decrypt sensitive fields if encryption is supported and key requires it
      if (data && KEYS_WITH_ENCRYPTION.includes(keyName) && EncryptionUtils.isEncryptionSupported()) {
        // Return a promise for async decryption
        return EncryptionUtils.decryptSensitiveFields(data);
      }

      return data;
    } catch (e) {
      return null;
    }
  }
}

async function addToWebStorage(keyName, keyValue) {
  if (web_storage && web_storage.setItem) {
    let valueToStore = keyValue;
    // Encrypt sensitive fields if encryption is supported and key requires it
    if (KEYS_WITH_ENCRYPTION.includes(keyName) && EncryptionUtils.isEncryptionSupported()) {
      valueToStore = await EncryptionUtils.encryptSensitiveFields(keyValue);
    }

    web_storage.setItem(keyName, JSON.stringify(valueToStore));
  }
}

async function updateInWebStorage(keyName, keyValue) {
  let valueToStore = keyValue;

  // Encrypt sensitive fields if encryption is supported and key requires it
  if (KEYS_WITH_ENCRYPTION.includes(keyName) && EncryptionUtils.isEncryptionSupported()) {
    valueToStore = await EncryptionUtils.encryptSensitiveFields(keyValue);
  }

  web_storage[keyName] = JSON.stringify(valueToStore);
}

function removeFromWebStorage(keyName) {
  if (web_storage && web_storage.removeItem) {
    web_storage.removeItem(keyName);
  }
}

function clearWebStorage() {
  if (web_storage && web_storage.clear) {
    web_storage.clear();
  }
}

module.exports = {
  getFromWebStorage,
  addToWebStorage,
  updateInWebStorage,
  removeFromWebStorage,
  clearWebStorage
};
